<template>
    <div id="login-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">

            <div class="modal-content">
                <div class="modal-body">

                    <div v-if="isScanning" style="text-align: center; color: black; text-shadow: #1f2d3d">
                        <!-- Scan QR-->
                    </div>

                    <qrcode-stream v-if="!isReset && visibleModal" :camera="camera" @decode="onDecode" @init="onInit">

                        <div v-if="validationSuccess" class="validation-success">
                            <!--QR code scanned-->
                        </div>

                        <div v-if="validationFailure" class="validation-failure">
                            <!--QR code not valid-->
                        </div>

                        <div v-if="!isCameraAvailable" class="validation-failure">
                            <!--Webcam camera not available-->
                        </div>
                        <div v-if="validationPending" class="validation-pending">
                            <!--Long validation in progress...-->
                        </div>
                    </qrcode-stream>

                    <div class="frame">
                        <img src="../../assets/imgs/general/camera-border.png" alt="" class="img-fluid">
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {QrcodeStream} from 'vue-qrcode-reader'
    import Swal from 'sweetalert2';

    const Toast = Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 3000
    });

    export default {
        name: "LoginModal",
        components: {QrcodeStream},

        data() {
            return {
                isValid: undefined,
                camera: 'auto',
                result: null,
                isReset: false,
                isCameraAvailable: true,
                visibleModal: false
            }
        },

        computed: {
            validationPending() {
                return this.isValid === undefined &&
                    this.camera === 'off'
            },

            isScanning() {
                return this.isValid === undefined &&
                    this.isCameraAvailable && !this.isReset
            },

            validationSuccess() {
                return this.isValid === true
            },

            validationFailure() {
                return this.isValid === false
            }
        },
        mounted() {
            const $ = window.$;
            let self = this;

            $('#login-modal').on("show.bs.modal", function () {
                self.visibleModal = true;

                if (!this.isCameraAvailable) {
                    Toast.fire({
                        type: 'warning',
                        title: 'Pentru a putea scana QR codul este nevoie de camera!',
                        animation: true,
                        customClass: {
                            popup: 'animated tada'
                        }
                    });
                }

                navigator.permissions.query({name: 'camera'})
                    .then((permissionStatus) => {
                        if (permissionStatus.state == 'granted') {
                            console.log('granted');
                            self.turnCameraOn();
                        } else if (permissionStatus.state == 'prompt') {
                            Toast.fire({
                                title: 'Te rugam accepta permisiunea pentru a putea scana QR codul!',
                                type: 'warning',
                                animation: false,
                                customClass: {
                                    popup: 'animated tada'
                                }
                            });
                        } else {
                            Toast.fire({
                                title: 'Pentru a putea scana QR codul este nevoie de permisiune pentru camera!',
                                type: 'error',
                                animation: false,
                                customClass: {
                                    popup: 'animated tada'
                                }
                            });
                        }
                        permissionStatus.onchange = (event) => {
                            const state = event.currentTarget.state;
                            if (state == 'granted') {
                                console.log('granted');
                                self.turnCameraOn();
                            } else {
                                Toast.fire({
                                    title: 'Pentru a putea scana QR codul este nevoie de permisiune pentru camera!',

                                    type: 'error',
                                    animation: false,
                                    customClass: {
                                        popup: 'animated tada'
                                    }
                                });
                            }
                        };
                    })
                    .catch(error => {
                        console.log('Camera permission failed', error);
                    });


            });

            $('#login-modal').on("hidden.bs.modal", function () {
                self.visibleModal = false;
            });
        },
        methods: {

            onInit(promise) {
                promise
                    .catch(() => {
                        this.isCameraAvailable = false
                    })
                    .then(this.resetValidationState)
            },

            resetValidationState() {
                this.isValid = undefined
            },

            async onDecode(content) {
                this.result = content
                this.turnCameraOff()

                this.isValid = content.toString().length > 3 && !content.startsWith('http')
                this.$emit('codeScanned', content);
                this.turnCameraOn()
            },

            turnCameraOn() {
                this.camera = 'auto'
            },

            turnCameraOff() {
                this.camera = 'off'
            },
            reset() {
                this.isReset = true
                this.$nextTick(() => {
                    this.isReset = false
                })
            }
        }
    }
</script>

<style lang="scss">
    @import '../../styles/login-modal.scss';
</style>